<div class="lm" [class.lm-admin]="mod === 'admin'">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Lemorzsolódással veszélyeztetett tanulók</ion-card-title>
      <ion-card-subtitle>
        A korai jelző rendszer (229/2012. Korm. r. 26/A. §) 44/J. § (2) szerinti jelzései az 5–12. évfolyamon: gyenge vagy romló
        átlag, elégtelen, rossz magatartás, hanyag szorgalom, évismétlés, 50 igazolatlan óra, szülői kérésre egyéni munkarend,
        menekült, veszélyeztetett, elhelyezett, illetve legalább két további körülmény (100 igazolt óra, kiemelt figyelmet igénylő,
        rendszeres gyermekvédelmi kedvezmény, 16 éves általános iskolás, 16 év felett lépett a középfokba).
        <span *ngIf="mod === 'admin'">Az összesített, névtelen adatot a Hivatalnak február 10-ig (I. félév) és június 30-ig (II. félév) kell továbbítani.</span>
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <!-- Határidő (admin) -->
      <div class="lm-hatarido" *ngIf="mod === 'admin' && adat?.hatarido as h" [class.lm-surgos]="h.emlekezteto">
        <ion-icon name="alarm-outline"></ion-icon>
        <span>
          Következő beküldési határidő: <b>{{ datum(h.hatarido) }}</b> ({{ h.felev === 1 ? 'I.' : 'II.' }} félév) –
          <b>{{ h.napok }}</b> nap van hátra.
          <span *ngIf="h.emlekezteto"> Ideje elkészíteni és továbbítani az összesített adatot.</span>
        </span>
      </div>

      <div class="lm-szurok">
        <ion-segment [value]="felev" (ionChange)="felevValt($event.detail.value)">
          <ion-segment-button [value]="1"><ion-label>I. félév (febr. 10.)</ion-label></ion-segment-button>
          <ion-segment-button [value]="2"><ion-label>II. félév (jún. 30.)</ion-label></ion-segment-button>
        </ion-segment>
        <div class="lm-sor">
          <ion-select *ngIf="mod === 'admin'" label="Osztály" label-placement="stacked" interface="popover"
                      [(ngModel)]="szuroOsztaly" (ionChange)="osztalyValt()">
            <ion-select-option value="">Mind (5–12. évfolyam)</ion-select-option>
            <ion-select-option *ngFor="let o of adat?.osztalyok || []" [value]="o.id">{{ o.nev }}</ion-select-option>
          </ion-select>
          <ion-toggle [(ngModel)]="csakVeszelyeztetett" labelPlacement="end">Csak a veszélyeztetettek</ion-toggle>
          <ion-button fill="outline" size="small" (click)="csv()" [disabled]="!sorok.length">
            <ion-icon slot="start" name="download-outline"></ion-icon>CSV
          </ion-button>
          <ng-container *ngIf="mod === 'admin'">
            <ion-checkbox [(ngModel)]="varhatoRiportban" labelPlacement="end">a még le nem zárt (várható) jelzésekkel</ion-checkbox>
            <ion-button size="small" (click)="riport()" [disabled]="letoltes || !adat">
              <ion-icon slot="start" name="document-text-outline"></ion-icon>{{ letoltes ? 'Készül…' : 'Összesített adatszolgáltatás (PDF)' }}
            </ion-button>
          </ng-container>
        </div>
      </div>

      <div *ngIf="betolt" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>
      <p class="lm-hiba" *ngIf="hiba">{{ hiba }}</p>

      <ng-container *ngIf="adat && !betolt && !hiba">
        <p class="lm-halvany">
          {{ adat.tanev.nev }} tanév · {{ adat.idoszak.felev === 1 ? 'I.' : 'II.' }} félév: {{ datum(adat.idoszak.tol) }} – {{ datum(adat.idoszak.ig) }}
          <span *ngIf="!adat.idoszak.lezart"> (folyamatban; a mulasztás {{ datum(adat.idoszak.mulasztas_ig) }}-ig)</span> ·
          <b>{{ veszelyeztetettDb }}</b> veszélyeztetett tanuló {{ adat.tanulok.length }} tanulóból
          <span *ngIf="csakVarhatoDb"> · ebből <b>{{ csakVarhatoDb }}</b> csak várható jelzéssel</span>
          <span *ngIf="adat.megjegyzes"> · {{ adat.megjegyzes }}</span>
        </p>
        <p class="lm-halvany" *ngIf="zarojegyNelkulDb && adat.tanulok.length">
          {{ zarojegyNelkulDb }} tanulónak még nincs {{ adat.idoszak.felev === 1 ? 'félévi' : 'év végi' }} osztályzata: náluk az átlag és az
          elégtelen <b>várható</b> érték (*) – a tantárgyankénti évközi súlyozott átlagból (legalább 3 jegy), a riportba csak külön jelölve kerül.
        </p>

        <div class="lm-pontok" *ngIf="adat.tanulok.length">
          <span *ngFor="let k of kriteriumok" class="lm-pont" [class.lm-van]="pontDb(k.kod)" [title]="k.pont + ' – ' + k.leiras">
            {{ k.kod }}) {{ k.rovid }}: <b>{{ pontDb(k.kod) }}</b>
          </span>
        </div>

        <p class="lm-halvany" *ngIf="!sorok.length && adat.tanulok.length">Nincs lemorzsolódással veszélyeztetett tanuló ebben az időszakban.</p>

        <table class="lm-lista" *ngIf="sorok.length">
          <thead>
            <tr>
              <th>Tanuló</th><th *ngIf="mod === 'admin'">Osztály</th>
              <th *ngFor="let k of kriteriumok" class="lm-sz" [title]="k.pont + ' – ' + k.nev">{{ k.kod }}</th>
              <th class="lm-sz" title="Igazolt / igazolatlan óra a félévben (egyéb foglalkozással, késéssel)">Mulasztás</th>
              <th class="lm-sz">Intézkedés</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let t of sorok">
              <tr class="lm-kattinthato" (click)="valt(t)" [class.lm-vesz]="t.veszelyeztetett && !t.csak_varhato" [class.lm-varhato]="t.csak_varhato">
                <td><b>{{ t.nev }}</b></td>
                <td *ngIf="mod === 'admin'">{{ t.osztaly }}</td>
                <td *ngFor="let k of kriteriumok" class="lm-sz" [title]="teljesul(t, k.kod) ? cimke(t, k) : ''">
                  <span *ngIf="teljesul(t, k.kod)" class="lm-jel" [class.lm-jel-varhato]="varhato(t, k.kod)">●<sup *ngIf="varhato(t, k.kod)">*</sup></span>
                </td>
                <td class="lm-sz">{{ t.mulasztas.igazolt }} / <span [class.lm-piros]="t.mulasztas.igazolatlan >= 50">{{ t.mulasztas.igazolatlan }}</span></td>
                <td class="lm-sz">{{ t.intezkedesek.length || '–' }}</td>
              </tr>
              <tr *ngIf="nyitva[t.oktazon]" class="lm-reszlet">
                <td [attr.colspan]="kriteriumok.length + (mod === 'admin' ? 4 : 3)">
                  <div class="lm-reszlet-belso">
                    <div>
                      <h4>Jelzések</h4>
                      <ul>
                        <li *ngFor="let k of teljesultek(t)">
                          <b>{{ k.kod }}) {{ k.nev }}</b><span *ngIf="t.kriteriumok[k.kod]?.szoveg">: {{ t.kriteriumok[k.kod]?.szoveg }}</span>
                          <span class="lm-halvany" *ngIf="varhato(t, k.kod)"> – várható (még nincs zárójegy)</span>
                          <span class="lm-halvany"> · {{ k.pont }}</span>
                        </li>
                        <li *ngIf="!teljesultek(t).length" class="lm-halvany">Nincs jelzés.</li>
                      </ul>
                      <p class="lm-halvany" *ngIf="t.kriteriumok['a']?.szoveg && !teljesul(t, 'a')">Átlag: {{ t.kriteriumok['a']?.szoveg }}</p>
                      <p class="lm-figyel" *ngFor="let f of t.figyelmeztetesek">{{ f }}</p>
                      <p class="lm-halvany">
                        Mulasztás a félévben: {{ t.mulasztas.igazolt }} igazolt, {{ t.mulasztas.igazolatlan }} igazolatlan
                        <span *ngIf="t.mulasztas.elbiralatlan">, {{ t.mulasztas.elbiralatlan }} elbírálatlan</span> óra.
                      </p>
                      <details *ngIf="t.targyak.length">
                        <summary>{{ t.hivatalos ? 'Zárójegyek' : 'Várható osztályzatok' }} ({{ t.targyak.length }} tantárgy)</summary>
                        <span *ngFor="let j of t.targyak; let l = last">{{ j.nev }}: {{ jegySzoveg(j) }}{{ l ? '' : ' · ' }}</span>
                      </details>
                    </div>
                    <div>
                      <h4>Alkalmazott intézkedések ({{ adat.idoszak.felev === 1 ? 'I.' : 'II.' }} félév)</h4>
                      <ul>
                        <li *ngFor="let x of t.intezkedesek">
                          {{ datum(x.datum) || x.rogzitve }} – <b>{{ tipusNev(x.tipus) }}</b>
                          <span *ngIf="x.tantargy"> ({{ targyNev(t, x.tantargy) || 'tantárgy' }})</span>
                          <span *ngIf="x.megjegyzes">: {{ x.megjegyzes }}</span>
                          <span class="lm-halvany" *ngIf="x.rogzitette"> · {{ x.rogzitette }}</span>
                          <ion-button size="small" fill="clear" color="danger" (click)="intezkedesTorol(t, x)">
                            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                          </ion-button>
                        </li>
                        <li *ngIf="!t.intezkedesek.length" class="lm-halvany">Még nincs rögzített intézkedés.</li>
                      </ul>
                      <div class="lm-uj" *ngIf="uj[t.oktazon] as u">
                        <ion-select label="Intézkedés" label-placement="stacked" interface="popover" [(ngModel)]="u.tipus">
                          <ion-select-option *ngFor="let it of intezkedesTipusok" [value]="it.kod">{{ it.nev }}</ion-select-option>
                        </ion-select>
                        <ion-select label="Tantárgy (ha ahhoz kötődik)" label-placement="stacked" interface="popover" [(ngModel)]="u.tantargy">
                          <ion-select-option value="">–</ion-select-option>
                          <ion-select-option *ngFor="let j of t.targyak" [value]="j.id">{{ j.nev }}</ion-select-option>
                        </ion-select>
                        <ion-input type="date" label="Dátum" label-placement="stacked" [(ngModel)]="u.datum"></ion-input>
                        <ion-input label="Megjegyzés" label-placement="stacked" maxlength="1000" [(ngModel)]="u.megjegyzes"></ion-input>
                        <ion-button size="small" (click)="intezkedesMent(t)" [disabled]="mentes || !u.tipus">Rögzítés</ion-button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <p class="lm-halvany lm-jogalap">
          ● = teljesül, ●* = várható (még nincs zárójegy). A névsoros lista az iskola belső, pedagógiai célú nézete; a Hivatalnak csak
          az összesített, személyazonosításra alkalmatlan adat megy (229/2012. Korm. r. 1. § (2) 21. pont). Jogalap: {{ adat.jogalap }}.
          Mulasztás: a félévben, a tanítási órák és az egyéb foglalkozások (napközi is) együtt, a késésekből összegyűlt órákkal.
        </p>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
